import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import { FiChevronDown, FiChevronLeft, FiEye, FiPlus } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { FormatDateTime } from "../../../../../../utils/functions/ResourceFunctions";
import {
  GetAllCreditFacility,
  PostReverseFT,
} from "../../../../../../utils/redux/Finance/AccountingSetup/AccountingSetupSlice";
import DashboardStyle from "../../../../../dashboard/Styles/Dashboard.module.css";
import ClickAwayListener from "../../../../Components/Misc/ClickAwayListener";
import Pagination from "../../../../Components/Pagination/Pagination";
import {
  ActionButton,
  CalendarFilter2,
  ProDropFilter,
  SearchFilter,
} from "../../../../Components/Search/Search";
import Table from "../../../../Components/Table/Table";
import "./component.css";
import { FormatCurrency } from "../../../../../../utils/functions/FormatCurrency";
import { Box, Modal } from "@mui/material";
import axios from "axios";
import { toast } from "react-toastify";
import { useFinanceGetQuery } from "../../../../../api/financeApi";
import { Link } from "react-router-dom";
import { URL } from "../../../../../../utils/routes";
import { GoPencil } from "react-icons/go";
import { Delete } from "@mui/icons-material";
import { useApprovals } from "../../../Vendors/VendorApprovals/useApprovals";
import { DisableCreditFacility } from "../../../../../../utils/redux/HR/HRSlice";
import SetupPrepayment from "./setupPrepayment";
const AcctTable = () => {
  // Filter states
  const [filters, setFilters] = useState([]);
  const [search, setSearch] = useState("");
  const [endDate, setEndDate] = useState();
  const [startDate, setStartDate] = useState();
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [status, setStatus] = useState(null);

  const [datas, setDatas] = useState({});
  //Select states
  const [selectAll, setSelectAll] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const dateFrom =
    startDate === undefined ? "" : format(new Date(startDate), "DD/MM/YYYY");
  const dateTo =
    endDate === undefined ? "" : format(new Date(endDate), "DD/MM/YYYY");

  const apiData = {
    // AccountName: search,
    filters: filters,
    ApprovalStatus: status,
    startDate: dateFrom,
    endDate: dateTo,
    pageSize: pageSize,
    pageNumber: pageNumber,
    Search: search,
  };

  useEffect(() => {
    setIsLoading(true);
    dispatch(GetAllCreditFacility(apiData)).then((res) => {
      setDatas(res.payload);
    });
    setIsLoading(false);
  }, [pageNumber, pageSize, search, status, endDate, startDate]);

  /**Data Fetching */

  const data =
    datas?.result?.items?.map((c) => ({
      id: c?.id,
      principal: c?.principal,
      vendorName: c?.vendorName,
      interestRate: c?.interestRate,
      tenor: c?.tenor,
      modeOfReceipt: c?.modeOfReceipt,
      approvalStatus: c?.approvalStatus,
      createdBy: c?.createdBy,
      createdDate: FormatDateTime(c?.createdDate),
    })) || null;

  // const data = null;

  /**Select One Action */
  const HandleSelectedItems = (itemId, checked) => {
    setSelectedItems((prevSelectedItems) => {
      if (checked) {
        return [...prevSelectedItems, itemId];
      } else {
        return prevSelectedItems.filter((id) => id !== itemId);
      }
    });
  };

  /**Select All Action */
  const handleSelectAllChange = () => {
    if (selectAll) {
      setSelectedItems([]);
    } else {
      const selectedItemIds = mockData.map((item) => item.id);
      setSelectedItems(selectedItemIds);
    }
    setSelectAll((prevSelectAll) => !prevSelectAll);
  };

  // Filter options to Map in Filter Modal
  const filterByClass = [
    {
      name: "All",
      filter: 0,
    },
    {
      name: "Cash Advance",
      filter: 1,
    },
    {
      name: "Post Service",
      filter: 2,
    },
    {
      name: "Cash Deduction",
      filter: 3,
    },
  ];

  const searchFilter = [
    {
      name: "Approved",
      filter: 0,
    },
    {
      name: "Pending",
      filter: 1,
    },
    {
      name: "Declined",
      filter: 2,
    },
    {
      name: "Canceled",
      filter: 11,
    },
  ];

  const StatusText = ({ status }) => {
    return (
      <span
        className={`
            ${
              status === "Approved"
                ? "bg-green-200 text-green-700"
                : status === "Declined"
                ? "bg-red-200 text-red-700"
                : "bg-yellow-200 text-yellow-700"
            }
          `}
        style={{
          textAlign: "center",
          padding: "0.3rem 0.6rem",
          borderRadius: "10px",
          fontSize: "0.875rem",
          fontWeight: "600",
        }}
      >
        {status}
      </span>
    );
  };
  // Format data result to look something like this:
  let mockData = [
    {
      id: 1,
      chartOfAcct: "Assets",
      mainAcct: "Leasehold buildings",
      subAcct: "Office furniture",
      status: <StatusText status="Approved" />,
    },
    {
      id: 2,
      chartOfAcct: "Assets",
      mainAcct: "Leasehold buildings",
      subAcct: "Office stationary",
      status: <StatusText status="Pending" />,
    },
    {
      id: 3,
      chartOfAcct: "Assets",
      mainAcct: "Motor Vehicle",
      subAcct: "Vehicle maintenance",
      status: <StatusText status="Declined" />,
    },
  ];

  // Table Headers format:
  let mockHeaders = [
    {
      title: "Id",
      key: "id",
    },
    {
      title: "Created By",
      key: "createdBy",
    },

    {
      title: "Principal",
      key: "principal",
    },
    {
      title: "Interest Rates",
      key: "interestRate",
    },
    {
      title: "Tenor",
      key: "tenor",
    },
    {
      title: "Vendor",
      key: "vendorName",
    },
    {
      title: "Mode Of Receipt",
      key: "modeOfReceipt",
    },
    {
      title: "Date Created",
      key: "createdDate",
    },

    {
      title: "Status",
      key: null,
    },
    {
      title: "Actions",
      key: null,
    },
  ];
  //   {name: "View", icon: <FiEye size={16} className="pt-1" />, action: (id)=> { navigate(`${id}/view`)}},
  //   {name: "Edit", icon: <FiCheck color="green" size={16} className="mt-0.5" />, action: ()=> {}},

  let mockRowOptions = [
    {
      name: "View Details",
      icon: <FiEye color="green" size={16} className="pt-1" />,
      action: () => {
        // handleViewStaff();
      },
    },
    {
      name: <span className="text-red-700">Reverse</span>,
      icon: <FiChevronLeft color="#E61B00" size={16} className="mt-0.5" />,
      action: (id) => {
        console.log(`This is Id ${id}`);
      },
    },
  ];

  return (
    <div className="tabContain">
      <div className="flex justify-between mb-2 items-center">
        <div className="flex space-x-4 items-center">
          <div className="searchGroup">
            <SearchFilter text={setSearch} />
          </div>

          <ProDropFilter
            className={"!w-48"}
            filter={status}
            setFilter={setStatus}
            name={"Status"}
            filterBy={searchFilter}
          />
          {/* <CalendarFilter2
            name="Select Date Range"
            setStartDate={setStartDate}
            setEndDate={setEndDate}
          /> */}
        </div>
        <Link
          to={URL.AddCreditFacility}
          className="bg-[#305F32] text-[#EFF6F0] hover:bg-[#2b562d] py-2 px-4 font-semibold rounded inline-flex items-center gap-2 text-sm h-10 outline outline-1 outline-[#305F32]"
        >
          New Setup
        </Link>
      </div>
      <div className={DashboardStyle.dashboard_table_holder}>
        <Table>
          <thead>
            <tr>
              {mockHeaders.map((header) => (
                <th key={header.key}>{header.title}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            <RequestTable
              isLoading={isLoading}
              data={data}
              keys={mockHeaders.map((header) => header.key)}
              selectable={false}
              HandleSelectedItems={HandleSelectedItems}
              selectedItems={selectedItems}
            />
          </tbody>
          {/* {data?.result === null ? (
            <p
              style={{
                marginTop: "30px",
                width: "100%",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              No result based on the search keywords
            </p>
          ) : null} */}
        </Table>
      </div>

      <Pagination
        last_page={datas?.responseObject?.previousPage}
        present_page={datas?.responseObject?.currentPage}
        totalRows={datas?.responseObject?.totalNumberOfPages}
        pageSize={pageSize}
        setPageSize={(page) => setPageSize(page)}
        click={(page) => setPageNumber(page)}
      />
    </div>
  );
};

export default AcctTable;

const TableAction = ({ id, data, spreadPayment }) => {
  const [dropOpen, setDropOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [record, setRecord] = useState("");
  const { openModal, closeModal } = useApprovals({});

  return (
    <>
      <SetupPrepayment record={record} setRecord={setRecord} />

      <ClickAwayListener onClickAway={() => setDropOpen(false)}>
        <div className="relative w-32">
          <div>
            <Link to={`VeiwCredit/${id}`} className="tablebtn half_border_left">
              <FiEye />
            </Link>

            <button
              className="tablebtn half_border_right"
              onClick={() => {
                setDropOpen(!dropOpen);
              }}
            >
              <FiChevronDown />
            </button>
          </div>
          {dropOpen ? (
            <div className={"more_options_modal"}>
              <Link
                to={`${URL.AddCreditFacility}?id=${id}`}
                className={"more_action_button"}
              >
                <GoPencil color="black" size={16} className="mt-0.5" />{" "}
                <span className="text-black ml-2">Edit</span>
              </Link>

              <Link to={`VeiwCredit/${id}`} className={"more_action_button"}>
                <FiEye color="black" size={16} className="mt-0.5" />{" "}
                <span className="text-black ml-2">View</span>
              </Link>

              <button
                className={"more_action_button"}
                onClick={() => {
                  setRecord(data);
                }}
              >
                <FiPlus color="black" size={16} className="mt-0.5" />{" "}
                <span className="text-black ml-2">Setup Prepayment Plan</span>
              </button>

              <button
                className={"more_action_button"}
                onClick={() => {
                  openModal({
                    type: "suspend",
                    details: {
                      button: {
                        name: "Delete",
                        color: "red",
                      },
                      isDelete: true,
                      isDeleteHero: "",
                      isDeleteSupport:
                        "Are you sure you want to delete this data? This action cannot be undone.",
                      title: "Delete Credit Facility",
                      submitData: (data) => {
                        dispatch(
                          DisableCreditFacility({
                            id: id,
                          })
                        )?.then((res) => {
                          if (res?.payload?.successful === true) {
                            closeModal();
                            dispatch(
                              GetAllCreditFacility({
                                pageNumber: 1,
                                pageSize: 100,
                              })
                            );
                          } else {
                            toast.error(res?.payload?.statusMessage);
                          }
                        });
                      },
                    },
                  });
                }}
              >
                <Delete color="red" size={16} className="mt-0.5" />{" "}
                <span className="text-black ml-2">Disable</span>
              </button>
            </div>
          ) : null}
        </div>
      </ClickAwayListener>
    </>
  );
};

const StatusText = ({ status }) => {
  return (
    <span
      className={`
     ${
       status === "Approved"
         ? "bg-green-200 text-green-700"
         : status === "Pending"
         ? "bg-yellow-200 text-yellow-700"
         : "  bg-red-200 text-red-700"
     }
   `}
      style={{
        textAlign: "center",
        padding: "0.3rem 0.6rem",
        borderRadius: "10px",
        fontSize: "0.875rem",
        fontWeight: "600",
      }}
    >
      {status}
    </span>
  );
};

function RequestTable({
  data,
  keys,
  isLoading,
  selectable,
  spreadPayment,
  HandleSelectedItems,
  selectedItems,
  rowOptions,
}) {
  // const dispatch = useDispatch();
  const navigate = useNavigate();
  // console.log({data, keys})
  //

  //   const TableAction = ({id, data}) => (

  return (
    <>
      {isLoading ? (
        <tr
          style={{
            marginTop: "30px",
            width: "100%",
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          <td colSpan={4}>Loading!!!</td>
        </tr>
      ) : (
        data?.map((item) => (
          <tr key={item.id}>
            {keys
              .filter((key) => key)
              .map((key, i) => {
                return <td key={key}>{item[key]}</td>;
              })}
            {/**Status column if Any*/}
            <td>
              <StatusText status={item?.approvalStatus} />
            </td>
            <td>
              <TableAction
                data={item}
                ids={item?.id}
                spreadPayment={item?.spreadPayment}
                id={item?.id}
              />
            </td>

            {/* <td>
              // DEFAULT ACTION DROPDOWN
              <div className={`flex justify-end bg-transparent`}>
                <TableActions
                  children={rowOptions}
                  id={item?.id}
                  url={`${item?.id}/view`}
                >
                  {rowOptions}
                </TableActions>
              </div>
            </td> */}
          </tr>
        ))
      )}
    </>
  );
}
